import React from "react";

import { templates } from "@reactivated";

import { PDPSelectedVariantConditionalBlock } from "../apps/configurator/PDPSelectedVariantConditionalBlock";
import { IOptionCode } from "../models/catalogue";

export const Template = (
    props: templates.SelectedVariantConditionalBlockTemplate,
): React.JSX.Element => {
    return (
        <div>
            <PDPSelectedVariantConditionalBlock
                attributeCode={props.attribute_code as IOptionCode}
                attributeValue={props.attribute_value}
                contentSegments={props.content_segments}
                isInitiallyVisible={props.is_initially_visible}
            />
        </div>
    );
};
